class SwitchUserError extends Error {
    constructor(message, isRedirecting = false) {
        super(message);

        /**
         * Is a redirect to the login screen happening in response to this error?
         *
         * @type {boolean}
         */
        this.isRedirecting = isRedirecting;
    }
}

module.exports = SwitchUserError;
